// extracted by mini-css-extract-plugin
module.exports = {"primaryContent":"shop_primaryContent__kRKTO"};